import React, { useState } from "react";
import { MdArrowDropDownCircle,MdArrowDropUp  } from "react-icons/md";

/**
 * LoadMoreList - Reusable component for mobile card lists
 *
 * Props:
 *   data         {Array}    - Full filtered array of items to display
 *   renderItem   {Function} - (item, index) => JSX  — renders each card
 *   initialCount {Number}   - How many items to show initially (default: 5)
 *   noDataMessage{String}   - Message shown when data is empty (default: "No Result Found")
 */
const LoadMoreList = ({
  data = [],
  renderItem,
  initialCount = 5,
  noDataMessage = "No Result Found",
}) => {
  const [visibleCount, setVisibleCount] = useState(initialCount);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + initialCount);
  };

  const handleShowLess = () => {
    setVisibleCount(initialCount);
  };

  const visibleItems = data.slice(0, visibleCount);
  const hasMore = visibleCount < data.length;
  const canShowLess = visibleCount >= data.length && data.length > initialCount;

  if (data.length === 0) {
    return (
      <ul
        className="nav navbar-nav border border-grey p-4 mb-2 text-center"
        style={{ borderRadius: "20px" }}
      >
        {noDataMessage}
      </ul>
    );
  }

  return (
    <>
      {visibleItems.map((item, index) => renderItem(item, index))}

      {/* Record count */}
      <div className="text-center mt-1 mb-2">
        <small className="text-muted">
          Showing {Math.min(visibleCount, data.length)} of {data.length} record{data.length !== 1 ? "s" : ""}
        </small>
      </div>

      {/* Load More / Show Less buttons */}
      {(hasMore || canShowLess) && (
        <div className="text-center mt-1 mb-4">
          {hasMore && (
            <button
              type="button"
              onClick={handleLoadMore}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 22px",
                marginRight: "8px",
                borderRadius: "50px",
                border: "none",
                background: "linear-gradient(135deg, #4a90e2, #1a73e8)",
                color: "#fff",
                fontSize: "13px",
                fontWeight: "600",
                letterSpacing: "0.3px",
                boxShadow: "0 3px 10px rgba(26,115,232,0.35)",
                cursor: "pointer",
                transition: "transform 0.15s ease, box-shadow 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 16px rgba(26,115,232,0.45)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 3px 10px rgba(26,115,232,0.35)";
              }}
            >
              Show more
            <i className="fa fa-chevron-down" aria-hidden="true"></i>

            </button>
          )}
          {canShowLess && (
            <button
              type="button"
              onClick={handleShowLess}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 22px",
                borderRadius: "50px",
                border: "1.5px solid #6c757d",
                background: "#fff",
                color: "#6c757d",
                fontSize: "13px",
                fontWeight: "600",
                letterSpacing: "0.3px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                cursor: "pointer",
                transition: "transform 0.15s ease, box-shadow 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 5px 12px rgba(0,0,0,0.13)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.08)";
              }}
            >
              Show less
               <i className="fa fa-chevron-up" aria-hidden="true"></i>
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default LoadMoreList;
